import { render, staticRenderFns } from "./AdminServiceAreaForm.vue?vue&type=template&id=d57e9960"
import script from "./AdminServiceAreaForm.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports